var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MultiReplaceConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ReplaceSearchType } from './replaceConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
import { buildInputsMap, validateSourceWithDetail } from './validation/validateHelper';
import { multiReplaceConfigSchemaValidation } from '../validations.generated';
export const multiReplaceConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:MultiReplaceConfig',
    type: 'object',
    properties: {
        replaceConditions: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:ReplaceCondition' },
            minItems: 1
        }
    },
    required: ['replaceConditions']
};
let MultiReplaceConfig = MultiReplaceConfig_1 = class MultiReplaceConfig extends ToolConfig {
    constructor(replaceConditions, customFormats) {
        super(ToolType.MULTI_REPLACE, customFormats);
        this.replaceConditions = replaceConditions;
        JSON.validate(this, MultiReplaceConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return MultiReplaceConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return MultiReplaceConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return MultiReplaceConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return MultiReplaceConfig_1.outs;
    }
    static get in() {
        return MultiReplaceConfig_1.ins[0];
    }
    static get out() {
        return MultiReplaceConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.REPLACE.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CLEAN, ToolCategories.THE_BASICS, ToolCategories.TEXT_TOOLS], this.ins, this.outs, ['regex', 'regular expression', 'starts with', 'ends with'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        if (source) {
            const exp = tsb.export(this.out);
            const replaces = new Set();
            this.replaceConditions
                .map((replaceCondition) => replaceCondition.columns)
                .forEach((replaceConditionColumns) => replaceConditionColumns.forEach((column) => replaces.add(column)));
            const isReplaceColumn = replaces.size > 0
                ? (column) => {
                    return replaces.has(column.name);
                }
                : (column) => {
                    return column.type === 'string';
                };
            source.forEach((s) => {
                const isReplace = isReplaceColumn(s);
                exp.copy(this.in, s, isReplace, isReplace);
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, ins) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, ins);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        for (const condition of this.replaceConditions) {
            // Test to see if Regex is valid
            if (condition.searchType === ReplaceSearchType.REGEX) {
                try {
                    // eslint-disable-next-line no-new
                    new RegExp(condition.searchFor);
                }
                catch (e) {
                    return ToolValidationResult.getInvalidResult(`Invalid Regex. ${e}.`);
                }
            }
        }
        const replaces = new Set();
        this.replaceConditions
            .map((replaceCondition) => replaceCondition.columns)
            .forEach((replaceConditionColumns) => replaceConditionColumns.forEach((column) => replaces.add(column)));
        const inputs = buildInputsMap([...replaces], ['string']);
        const sourceValidationResult = validateSourceWithDetail(source, inputs, []);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
};
MultiReplaceConfig = MultiReplaceConfig_1 = __decorate([
    JsonSchemaV2(multiReplaceConfigSchema, multiReplaceConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.MULTI_REPLACE)
], MultiReplaceConfig);
export { MultiReplaceConfig };
//# sourceMappingURL=multiReplaceConfig.js.map